// src/components/contact/ContactMap.jsx
import React from "react";

const ContactMap = ({ googleMapUrl }) => {
  if (!googleMapUrl) return null;

  return (
    <div className="w-full">
      <div className="panel-elevated rounded-2xl p-2 md:p-4 overflow-hidden h-full min-h-[400px] md:min-h-[500px]">
        <iframe
          src={googleMapUrl}
          width="100%"
          height="100%"
          style={{ border: 0, minHeight: "400px" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="rounded-xl"
          title="CAS Systems Location"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactMap;


